import { Routes } from '@angular/router';
import { userIsLoggedInGuard } from '@core/guards/user-is-logged-in.guard';
import { TypeRouteEnum } from '@core/interfaces/route-type';

export const HOST_ROUTES: Routes = [
    {
        path: 'home',
        canActivate: [userIsLoggedInGuard],
        data: {
            type: TypeRouteEnum.PRIVATE
        },
        loadComponent: () => import('@ui/main/main.component'),
        children: [
            {
                path: '',
                loadChildren: () => import('@ui/pages/main.routes')
            }
        ]
    },

    {
        path: 'login',
        canActivate: [userIsLoggedInGuard],
        data: {
            type: TypeRouteEnum.PUBLIC
        },
        loadComponent: () => import('@shared/layout/templates/login/login.component'),
    },

    {
        path: 'register',
        canActivate: [userIsLoggedInGuard],
        data: {
            type: TypeRouteEnum.PUBLIC
        },
        loadComponent: () => import('@shared/layout/templates/login/login.component'),
    },

    {
        path: 'reset-password',
        data: {
            type: TypeRouteEnum.PUBLIC
        },
        loadComponent: () => import('@shared/layout/templates/reset-password/reset-password.component'),
    },

    { path: "", redirectTo: 'home', pathMatch: "full" },
    { path: "**", redirectTo: 'home', pathMatch: "full" }
];
